import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
    width: 100%;

    .label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 16px;
    }

    .label-error {
        color: #F84242;
        font-size: 14px;
        font-weight: 300;
        margin-top: 4px;
    }
`;

const TextAreaBox = styled.textarea`
    width: calc(100% - 16px);
    resize: none;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #FBE250;
    color: #25368D;
    font-size: 16px;
    font-weight: 400;
`;

function TextAreaComponent({
    label,
    value,
    row,
    placeholder,
    labelError,
    isError,
    disable,
    styleContainer,
    classContainer,
    onInput,
}) {
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        setInputValue(value || "");
    }, [value])

    function handleInput(param) {
        if (disable) return;
        let value = param.target.value;
        setInputValue(value)
        onInput && onInput(value)
    }

    return (
        <Container className={`${classContainer}`} style={{ ...styleContainer }}>
            {label && <div className="label">{label}</div>}
            <TextAreaBox
                rows={row || 4}
                className={`${isError ? "error" : ""}`}
                placeholder={placeholder || ""}
                value={inputValue}
                disabled={disable}
                onInput={(e) => { handleInput(e) }}
            />
            {isError && <div className="label-error">{labelError || "Invalid Input"}</div>}
        </Container>
    )
}

export default TextAreaComponent;